import { ApplicationEntity } from "@graffer-inc/cloud-gov-core";
import { useQualifiedInvoiceIssueRequest } from "./hooks";
import { QualifiedInvoiceIssueRequestRequested } from "./requested";
import { Redirect } from "react-router-dom";
import { SmartApplyR } from "../../../route";
import { QualifiedInvoiceRevokedList } from "./revoked-list";

type Props = {
  application: ApplicationEntity;
};

export const QualifiedInvoiceIssueRequest: React.FC<Props> = ({
  application,
}) => {
  const {
    redirectTo,
    isLoading,
    issueUIState,
    issueControlStatus,
    availableIssuedQualifiedInvoice,
    revokedQualifiedInvoices,
    handleOnSetRedirectToIssueForm,
    handleOnWithdraw,
    handleOnRevoke,
  } = useQualifiedInvoiceIssueRequest({
    application,
  });

  if (redirectTo === "ISSUE_FORM") {
    return (
      <Redirect
        to={SmartApplyR.ApplicationQualifiedInvoiceNew.link({
          id: application.id,
        })}
      />
    );
  }

  if (issueUIState === "HIDE_AREA") {
    return <></>;
  }

  return (
    <>
      <div className="columns mt-6">
        <div className="column">
          <h2 className="title is-size-4">支払い明細書</h2>
        </div>
      </div>
      <div className="mb-4">
        {issueUIState === "NO_REQUESTS" ? (
          <p>交付依頼はありません。</p>
        ) : (
          <QualifiedInvoiceIssueRequestRequested
            isLoading={isLoading}
            issueUIState={issueUIState}
            issueControlStatus={issueControlStatus}
            applicationId={application.id}
            availableIssuedQualifiedInvoice={availableIssuedQualifiedInvoice}
            handleOnSetRedirectToIssueForm={handleOnSetRedirectToIssueForm}
            handleOnWithdraw={handleOnWithdraw}
            handleOnRevoke={handleOnRevoke}
          />
        )}
      </div>
      {revokedQualifiedInvoices.length > 0 && (
        <QualifiedInvoiceRevokedList
          applicationId={application.id}
          revokedQualifiedInvoices={revokedQualifiedInvoices}
        />
      )}
    </>
  );
};
